export const measurementTableConfigKeys = {
  all: ['measurementTableConfig'] as const,
  lists: () => [...measurementTableConfigKeys.all, 'list'] as const,
  list: (filters: string) => [...measurementTableConfigKeys.lists(), { filters }] as const,
} as const;